export var CombinedRole;
(function (CombinedRole) {
    CombinedRole["AGENCY"] = "AGENCY";
    CombinedRole["PUBLISHER"] = "PUBLISHER";
})(CombinedRole || (CombinedRole = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["TOKEN"] = "token";
})(StorageKey || (StorageKey = {}));
